import { GET_STORE_LIST_DONE } from './constants';

export default {
  [GET_STORE_LIST_DONE](state, data) {
    state.storesInfos = data;
  },
};
